// src/components/JsConfetti.jsx
import React, { useRef, useEffect } from "react";
import JSConfetti from "js-confetti";

export default function JsConfetti({ fire = false, onDone }) {
  const jsConfetti = useRef(null);

  useEffect(() => {
    jsConfetti.current = new JSConfetti();
  }, []);

  useEffect(() => {
    if (fire && jsConfetti.current) {
      jsConfetti.current.addConfetti({
        emojis: ["🎉", "✨", "🍾"],
        emojiSize: 40,
        confettiNumber: 80,
      });
      if (onDone) onDone();
    }
  }, [fire, onDone]);

  return null; // no UI, just triggers confetti
}
